import React, { ReactNode, useContext, useMemo, useState } from "react";

import { EditorContext, IEditorContextValue } from "./EditorContext";

export const useEditorContext = () => {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error("useEditorContext must be used within EditorProvider");
  }
  return context;
};

interface IEditorProviderProps {
  children: ReactNode;
}

export const EditorProvider: React.FC<IEditorProviderProps> = ({ children }) => {
  const [copyStylesSourceProject, setCopyStylesSourceProject] = useState<IEditorContextValue["copyStylesSourceProject"]>(undefined);
  const [copyStylesSourceVersion, setCopyStylesSourceVersion] = useState<IEditorContextValue["copyStylesSourceVersion"]>(undefined);

  const value: IEditorContextValue = useMemo(
    () => ({
      copyStylesSourceProject,
      copyStylesSourceVersion,
      setCopyStylesSourceProject,
      setCopyStylesSourceVersion,
    }),
    [copyStylesSourceProject, copyStylesSourceVersion]
  );

  return <EditorContext.Provider value={value}>{children}</EditorContext.Provider>;
};
